export const messageWidth = screenWidth => ({
  width: screenWidth ? (screenWidth * 70) / 100 + 'px' : '254px',
})

export const templateImgStyle = screenWidth => ({
  maxHeight: screenWidth ? (screenWidth * 45) / 100 + 'px' : '140px',
})
